$(document).ready(function() {
    // Foundation
    $(document).foundation();

    // Plugins


    // Sliders
    var owlTeachers = $("#teacherSlider");

    owlTeachers.owlCarousel({
        autoplay: true,
        autoplayTimeout: 4000,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 2,
            },
            650: {
                items: 3,
            },
            900: {
                items: 4,
            },
        },
    });

    // Custom Navigation Events
    $(".teachers .next").click(function() {
        owlTeachers.trigger('next.owl.carousel');
        return false;
    })
    $(".teachers .prev").click(function() {
        owlTeachers.trigger('prev.owl.carousel');
        return false;
    })


    // Sponsors
    var owlSponsors = $("#sponsorsSlider");

    owlSponsors.owlCarousel({
        // loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        margin: 10,
        responsive: {
            0: {
                items: 1,
            },
            650: {
                items: 2,
            },
            900: {
                items: 4,
            },
        },
    });
});


// Slider Home
$(window).load(function() {
    $('div#slideHome').smoothSlides({
        effectDuration: 3000,
        transitionDuration: 800,
        navigation: false,
        pagination: false
    });
});
